import React from 'react';
import fraudmajor from '../images/fraudmajor.png';
import profilemajor from '../images/profilemajor.png';
import barcodemajor from '../images/barcodemajor.png';
import cashdollarmajor from '../images/cashdollarmajor.png';
import { Banner, InlineStack, Icon, Link, List, Text, Tooltip, BlockStack } from '@shopify/polaris';
import { BarcodeMajor, SecureMajor } from '@shopify/polaris-icons';
import { hasLength } from '../../Editproduct/utils/customHelperFunctions';
import { savechecklist } from '../onboardingApi';
import { isBrowserStorageDisabled } from '../../../../Actions/index';
import { useTranslation } from 'react-i18next';


export const initialOnboardingStates = {
    seller_type: '',
    steps_completed: 0,
    selected_region: '',
    region: [],
    region_text: '',
    account_name: '',
    settings_preferences: {
        price: false,
        inventory: false,
        product_details: false,
        images: false
    },
    product_settings: {
        sku: true,
        barcode: false
    },
    fulfillment_settings: {
        fbm: true,
        fba: false
    },
    modal: {
        isOpen: false,
        title: '',
        data: []
    },
    isAccountConnected: false,
    account: {
        shopify: {},
        amazon: []
    }
}

export const onboardingErrors = {
    match_from_amazon: false,
    sync_status_fulfillment: false,
    seller_type: false,
    steps_completed: false,
    selected_region: false,
    region: false,
    account_name: false,
    seller: false,
    registered_brand: false,
    not_registered_brand: false,
    previous_used_app: false,
    previous_used_app_value: false,
    deactivateProduct: false

}

export const initialOnboardingLoaders = {
    connectAmazonLoader: false,
    accountName: false,
    sellerType: false,
    settingPrefrences: false
}

export const seller_type_options = [
    { label: 'New Amazon Seller', value: 'new_seller', helpText: 'Proceed with this option if you are new to selling on Amazon, and want to list your Shopify products in Amazon marketplace.' },
    { label: 'Existing Amazon Seller?', value: 'existing_seller', helpText: "Proceed with this option if you are an existing seller, selling on Amazon marketplace, and already have Listings in Amazon seller account." },
]


export const secondStepInitialStates = {
    confirm_requirments: true,
    listItems: []
}

export const thirdStepInitialStates = {
    settings_selected: {
        pricing_plan: false,
        inventory: false,
        product_details: false
    }
}

export const secondStepListForNewSeller = [
    {
        id: 1,
        heading: 'You must have a Professional account of Amazon Seller Central with an updated payment method.',
        subheading: 'You cannot connect the accounts with Amazon-pay or other accounts.',
        type: 'new_seller'
    },
    {
        id: 2,
        heading: 'You cannot connect the accounts with Amazon Pay or other accounts.',
        subheading: '',
        type: 'new_seller'
    },
    {
        id: 3,
        heading: 'All your products brands must be approved by the Amazon marketplace (if not, need not worry, you can always manage it later).',
        subheading: '',
        type: 'new_seller'
    },
    {
        id: 4,
        heading: 'Must have valid barcodes (GS1 approved barcodes) or barcode exemption from Amazon.',
        subheading: '',
        type: 'new_seller'
    }
]

export const secondStepListForExistingSeller = [
    {
        id: 1,
        heading: 'Account must not be in vacation mode.',
        subheading: '',
        type: 'existing_seller'
    },
    {
        id: 2,
        heading: 'Your payment method must be up-to-date.',
        subheading: '',
        type: 'existing_seller'
    },
]

export default function getAvatar(type: number = 0, seller_type: string = '') {
    if (seller_type === 'new_seller')
        return type === 1 ? profilemajor : type === 2 ? cashdollarmajor : type === 3 ? fraudmajor : barcodemajor;
    else if (seller_type === 'existing_seller')
        return type === 1 ? profilemajor : fraudmajor;
}

export function sortCountryByName(countries: any = []) {
    countries.sort(function (a: any, b: any) {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    })
    return [...countries]
}

export const amazon_regions_onboarding = (t: any) => [
    { value: "europe", label: t("Europe"), code: "EU", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: t("United Arab Emirates (U.A.E.)"),
        value: "AE",
        marketplace_id: "A2VIGQ35RCS4UG",
        region: "EU",
        currency: "AED",
        url: "Amazon.ae",
        currency_symbol: 'AED '
    },
    {
        label: t("Belgium"),
        value: "BE",
        marketplace_id: "AMEN7PMS3EDWL",
        region: "EU",
        currency: "Euro",
        url: "Amazon.com.be",
        currency_symbol: 'Euro '
    },
    {
        label: t("Germany"),
        value: "DE",
        marketplace_id: "A1PA6795UKMFR9",
        region: "EU",
        currency: "EUR",
        url: "Amazon.de",
        currency_symbol: '€ '
    },
    {
        label: t("Spain"),
        value: "ES",
        marketplace_id: "A1RKKUPIHCS9HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.es",
        currency_symbol: '€ '
    },
    {
        label: t("Saudi Arabia"),
        value: "SA",
        marketplace_id: "A17E79C6D8DWNP",
        region: "EU",
        currency: "Saudi Riyal",
        url: "Amazon.sa",
        currency_symbol: 'Saudi Riyal '
    },
    {
        label: t("Egypt"),
        value: "EG",
        marketplace_id: "ARBP9OOSHTCHU",
        region: "EU",
        currency: "Egyptian Pound",
        url: "Amazon.eg",
        currency_symbol: 'E£'
    },
    {
        label: t("Turkey"),
        value: "TR",
        marketplace_id: "A33AVAJ2PDY3EV",
        region: "EU",
        currency: "Turkish Lira",
        url: "Amazon.com.tr",
        currency_symbol: '₺'
    },
    {
        label: t("France"),
        value: "FR",
        marketplace_id: "A13V1IB3VIYZZH",
        region: "EU",
        currency: "EUR",
        url: "Amazon.fr",
        currency_symbol: '€ '
    },
    {
        label: t("UK"),
        value: "GB",
        marketplace_id: "A1F83G8C2ARO7P",
        region: "EU",
        currency: "GBP",
        url: "Amazon.co.uk",
        currency_symbol: '£ '
    },
    {
        label: t("India"),
        value: "IN",
        marketplace_id: "A21TJRUUN4KGV",
        region: "EU",
        currency: "INR",
        url: "Amazon.in",
        currency_symbol: '₹ '
    },
    {
        label: t("Italy"),
        value: "IT",
        marketplace_id: "APJ6JRA9NG5V4",
        region: "EU",
        currency: "EUR",
        url: "Amazon.it",
        currency_symbol: '€ '
    },
    {
        label: t("Netherlands"),
        value: "NL",
        marketplace_id: "A1805IZSGTT6HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.nl",
        currency_symbol: '€ '
    },
    {
        label: t("Poland"),
        value: "PO",
        marketplace_id: "A1C3SOZRARQ6R3",
        region: "EU",
        currency: "PLN",
        url: "Amazon.pl",
        currency_symbol: 'zł '
    },
    {
        label: t("South Africa"),
        value: "ZA",
        marketplace_id: "AE08WJ6YKNBMC",
        region: "EU",
        currency: "ZAR",
        url: "Amazon.co.za",
        currency_symbol: 'ZAR '
    },
    {
        label: t("Ireland"),
        value: "IE",
        marketplace_id: "A28R8C7NBKEWEA",
        region: "EU",
        currency: "Euro",
        url: "amazon.ie",
        currency_symbol: '€'
    },
    {
        label: t("Sweden"),
        value: "SE",
        marketplace_id: "A2NODRKZP88ZB9",
        region: "EU",
        currency: "SEK",
        url: "Amazon.se",
        currency_symbol: 'kr '
    }]),
    { value: "far_east", label: t("Far East"), code: "FE", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: t("Singapore"),
        value: "SG",
        marketplace_id: "A19VAU5U5O7RUS",
        region: "FE",
        currency: "SGD",
        url: "Amazon.com.sg",
        currency_symbol: 'S$ '
    },
    {
        label: t("Australia"),
        value: "AU",
        marketplace_id: "A39IBJ37TRP1C6",
        region: "FE",
        currency: "AUD",
        url: "Amazon.com.au",
        currency_symbol: '$ '
    },
    {
        label: t("Japan"),
        value: "JP",
        marketplace_id: "A1VC38T7YXB528",
        region: "FE",
        currency: "JPY",
        url: "Amazon.co.jp",
        currency_symbol: '¥ '
    },]),
    { value: "north_america", label: t("North America"), code: "NA", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: t("Brazil"),
        value: "BR",
        marketplace_id: "A2Q3Y263D00KWC",
        region: "NA",
        currency: "BRL",
        url: "Amazon.com.br",
        currency_symbol: 'R$ '
    },
    {
        label: t("Canada"),
        value: "CA",
        marketplace_id: "A2EUQ1WTGCTBG2",
        region: "NA",
        currency: "CAD",
        url: "Amazon.ca",
        currency_symbol: '$ '
    },
    {
        label: t("Mexico"),
        value: "MX",
        marketplace_id: "A1AM78C64UM0Y8",
        region: "NA",
        currency: "MXN",
        url: "Amazon.com.mx",
        currency_symbol: '$ '
    },
    {
        label: t("US"),
        value: "US",
        marketplace_id: "ATVPDKIKX0DER",
        region: "NA",
        currency: "USD",
        url: "Amazon.com",
        currency_symbol: '$ '
    },
        // {
        //     "label": "Switzerland",
        //     "value": "CH",
        //     "marketplace_id": "A1PA6795UKMFR9",
        //     "region": "EU",
        //     "currency": "CHF",
        //     "url": "Amazon.de",
        //     "currency_symbol": "CHF "
        // }
    ]
    )
];

export const amazon_regions = [
    { value: "europe", label: "Europe", code: "EU", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: "United Arab Emirates (U.A.E.)",
        value: "AE",
        marketplace_id: "A2VIGQ35RCS4UG",
        region: "EU",
        currency: "AED",
        url: "Amazon.ae",
        currency_symbol: 'AED '
    },
    {
        label: "Belgium",
        value: "BE",
        marketplace_id: "AMEN7PMS3EDWL",
        region: "EU",
        currency: "Euro",
        url: "Amazon.com.be",
        currency_symbol: 'Euro '
    },
    {
        label: "Germany",
        value: "DE",
        marketplace_id: "A1PA6795UKMFR9",
        region: "EU",
        currency: "EUR",
        url: "Amazon.de",
        currency_symbol: '€ '
    },
    {
        label: "Spain",
        value: "ES",
        marketplace_id: "A1RKKUPIHCS9HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.es",
        currency_symbol: '€ '
    },
    {
        label: "Saudi Arabia",
        value: "SA",
        marketplace_id: "A17E79C6D8DWNP",
        region: "EU",
        currency: "Saudi Riyal",
        url: "Amazon.sa",
        currency_symbol: 'Saudi Riyal '
    },
    {
        label: "Egypt",
        value: "EG",
        marketplace_id: "ARBP9OOSHTCHU",
        region: "EU",
        currency: "Egyptian Pound",
        url: "Amazon.eg",
        currency_symbol: 'E£'
    },
    {
        label: "Turkey",
        value: "TR",
        marketplace_id: "A33AVAJ2PDY3EV",
        region: "EU",
        currency: "Turkish Lira",
        url: "Amazon.com.tr",
        currency_symbol: '₺'
    },
    {
        label: "France",
        value: "FR",
        marketplace_id: "A13V1IB3VIYZZH",
        region: "EU",
        currency: "EUR",
        url: "Amazon.fr",
        currency_symbol: '€ '
    },
    {
        label: "UK",
        value: "GB",
        marketplace_id: "A1F83G8C2ARO7P",
        region: "EU",
        currency: "GBP",
        url: "Amazon.co.uk",
        currency_symbol: '£ '
    },
    {
        label: "India",
        value: "IN",
        marketplace_id: "A21TJRUUN4KGV",
        region: "EU",
        currency: "INR",
        url: "Amazon.in",
        currency_symbol: '₹ '
    },
    {
        label: "Italy",
        value: "IT",
        marketplace_id: "APJ6JRA9NG5V4",
        region: "EU",
        currency: "EUR",
        url: "Amazon.it",
        currency_symbol: '€ '
    },
    {
        label: "Netherlands",
        value: "NL",
        marketplace_id: "A1805IZSGTT6HS",
        region: "EU",
        currency: "EUR",
        url: "Amazon.nl",
        currency_symbol: '€ '
    },
    {
        label: "Poland",
        value: "PO",
        marketplace_id: "A1C3SOZRARQ6R3",
        region: "EU",
        currency: "PLN",
        url: "Amazon.pl",
        currency_symbol: 'zł '
    },
    {
        label: "South Africa",
        value: "ZA",
        marketplace_id: "AE08WJ6YKNBMC",
        region: "EU",
        currency: "ZAR",
        url: "Amazon.co.za",
        currency_symbol: 'ZAR '
    },
    {
        label: "Sweden",
        value: "SE",
        marketplace_id: "A2NODRKZP88ZB9",
        region: "EU",
        currency: "SEK",
        url: "Amazon.se",
        currency_symbol: 'kr '
    }]),
    { value: "far_east", label: "Far East", code: "FE", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: "Singapore",
        value: "SG",
        marketplace_id: "A19VAU5U5O7RUS",
        region: "FE",
        currency: "SGD",
        url: "Amazon.com.sg",
        currency_symbol: 'S$ '
    },
    {
        label: "Australia",
        value: "AU",
        marketplace_id: "A39IBJ37TRP1C6",
        region: "FE",
        currency: "AUD",
        url: "Amazon.com.au",
        currency_symbol: '$ '
    },
    {
        label: "Japan",
        value: "JP",
        marketplace_id: "A1VC38T7YXB528",
        region: "FE",
        currency: "JPY",
        url: "Amazon.co.jp",
        currency_symbol: '¥ '
    },]),
    { value: "north_america", label: "North America", code: "NA", marketplace_id: '', disabled: true },
    ...sortCountryByName([{
        label: "Brazil",
        value: "BR",
        marketplace_id: "A2Q3Y263D00KWC",
        region: "NA",
        currency: "BRL",
        url: "Amazon.com.br",
        currency_symbol: 'R$ '
    },
    {
        label: "Canada",
        value: "CA",
        marketplace_id: "A2EUQ1WTGCTBG2",
        region: "NA",
        currency: "CAD",
        url: "Amazon.ca",
        currency_symbol: '$ '
    },
    {
        label: "Mexico",
        value: "MX",
        marketplace_id: "A1AM78C64UM0Y8",
        region: "NA",
        currency: "MXN",
        url: "Amazon.com.mx",
        currency_symbol: '$ '
    },
    {
        label: "US",
        value: "US",
        marketplace_id: "ATVPDKIKX0DER",
        region: "NA",
        currency: "USD",
        url: "Amazon.com",
        currency_symbol: '$ '
    },
    {
        label: "IE",
        value: "IE",
        marketplace_id: "A28R8C7NBKEWEA",
        region: "EU",
        currency: "Euro",
        url: "amazon.ie",
        currency_symbol: '€'
    },
        // {
        //     "label": "Switzerland",
        //     "value": "CH",
        //     "marketplace_id": "A1PA6795UKMFR9",
        //     "region": "EU",
        //     "currency": "CHF",
        //     "url": "Amazon.de",
        //     "currency_symbol": "CHF "
        // }
    ]
    )
];

export const customAsterisk = <span style={{ color: 'red' }} > *</span>

export const accont_connection_list = () => {
    let { t } = useTranslation();
    let opt = [
        {
            label: t('Primary access to Amazon Seller Central account.'),
            value: 'primary_access_seller_account',
        },
        {
            label: t('A seller account that is not suspended, inactive or in vacation mode.'),
            value: 'seller_account_not_suspended',
        },
        {
            label: <>
                <InlineStack gap="100">
                    <Text as='p'>{t("Amazon Professional account with updated")}</Text>
                    <Tooltip content={t("The Credit / Debit Card or other mode of payment associated with your Amazon Seller account must be active & in running state.")}>
                        <div className='dashed'>
                            <Text as='p'>{t("Payment Method.")}</Text>
                        </div>
                    </Tooltip>
                </InlineStack>
            </>,
            value: 'professional_account_with_payment_method',
        },
        {
            label: t('Connect only a professional seller account, not Amazon Pay and other account types.'),
            value: 'not_amazon_pay_account',
        },
    ]
    return { accont_connection_list_opt: opt }
}

export function removeDataFromLocalStorage(item: any) {
    try {
        // if (localStorage) {
        //     localStorage?.removeItem(item)
        // }
    } catch (error) {

    }
}
export function newSellerModalRenderer(t: any) {
    let tempStructure: any = [
        {
            icon: SecureMajor,
            text: <div>{t("Your products have Brands approved by Amazon. If that is not the case, you can")} {' '}
                <Link target='_blank' url='https://brandservices.amazon.com/brandregistry'>{t("manage it here.")}</Link></div>

        },
        {
            icon: BarcodeMajor,
            text: <div>{t("Your products either have valid barcodes approved by GS1 or Barcode Exemption from Amazon.")}</div>
            // <Link target='_blank' url='https://sellercentral.amazon.com/gtinx'>Reference Link</Link></div>
        }
    ]
    return <>
        <BlockStack gap="500">
            <BlockStack gap="300">
                <Text as='p' fontWeight='semibold'>{t("If you are a New Amazon Seller, make sure:")}</Text>
                <BlockStack gap="200">
                    <CustomList list={tempStructure} options={{
                        variation: 'subdued'
                    }} />
                </BlockStack>
            </BlockStack>
            <Banner tone='warning' key={'Banner'}>
                <BlockStack gap="100">
                    <Text as='p' fontWeight='semibold'>{t("Consider this before you start")}</Text>
                    <List>
                        <List.Item>{t("You have not sold any products from this account.")}</List.Item>
                        <List.Item>{t("It might take 2-3 days for your account to work seamlessly with enabled features.")}</List.Item>
                    </List>
                </BlockStack>
            </Banner>
        </BlockStack>
    </>;
}

export function CustomList(list: customListI): any {
    let { list: listStructure, options } = list;
    let structure: any = [];
    listStructure.map(({ text, icon }) => {
        structure.push(<>
            <InlineStack gap="300" wrap={false}>
                <div>
                    <Icon source={icon} tone={options?.iconColor || 'base'} /></div>
                <div className='Custom-Stack-Item--fill'>
                    <Text as='p' tone={options?.variation || 'regular'}>{text}</Text>
                </div>
            </InlineStack>
        </>)
    })
    return structure;
}

interface customListI {
    list: any[],
    options?: {
        variation?: 'positive' | 'negative' | 'warning' | 'strong' | 'subdued' | 'code' | any,
        iconColor?: 'base' | 'subdued' | 'critical' | 'interactive' | 'warning' | 'info' | 'success' | 'primary' | null
    }
}

export async function prepareChecklist(states: any = {}, props: any = []) {
    let arr: any = [];
    if (props.di.globalState.get('account_checklist') !== null && !isBrowserStorageDisabled()) {
        let accont_connection_list = JSON.parse(props.di.globalState.get('account_checklist', true) || '');
        Object.keys(accont_connection_list).filter((ele, i) => {
            if (accont_connection_list[ele])
                arr.push(ele);
        });
        let accounts: any = {
            amazon_account: JSON.parse(props.di.globalState.get('amazon_account', true) || '') || {},
            shopify_account: JSON.parse(props.di.globalState.get('shopify_account', true) || '') || {}
        }
        await savechecklist(props, {
            "target": { "marketplace": "amazon", "shopId": `${accounts?.amazon_account?.['id'] ?? ''}` },
            "source": { "marketplace": "shopify", "shopId": `${accounts?.shopify_account?.['id'] ?? ''}` },
            "data": { "onboarding_checklist": arr }
        })
    }
    return arr || [];
}

export function clearSelectedStorage(props: any = [], arr: any[]) {
    if (hasLength(arr) && !isBrowserStorageDisabled()) {
        arr.forEach((elem: any) => {
            try {
                if (sessionStorage.getItem(elem)) {
                    sessionStorage.removeItem(elem);
                }
            } catch (error) {

            }
        })
    }
}